/**
 * @file 欢迅任务中心（赚现金 / 赚钻石）图片资源集中导出
 * @description
 *   开发期：`images/` 本地加载。
 *   上线 CDN：USE_CDN 改 true，图片上传到 CDN_PREFIX 目录，业务组件无需改动。
 */
import AvalonGTConfig from '@/utils/Config';
/** 上线 CDN 后改为 true */
var USE_CDN = true;
/** CDN 路径前缀（与 getH5ImgUrl 拼接） */
var CDN_PREFIX = 'task/huanxun/';
function img(name) {
    return AvalonGTConfig.Global.getH5ImgUrl(CDN_PREFIX + name);
}
var taskImgs = {
    /** 赚现金顶部背景（含人物 + 金币） */
    bgCash: img('bg-cash.png'),
    /** 赚钻石顶部背景（含钻石装饰） */
    bgDiamond: img('bg-diamond.png'),
    /** 金币奖励小图标 */
    iconGold: img('icon-gold.png'),
    /** 钻石奖励小图标 */
    iconDiamond: img('icon-diamond.png'),
};
export default taskImgs;
